import { SearchableSelect } from "@/components/shared/SearchableSelect";

export function SiteSelectField({ sites, value, onChange, testId, placeholder = "Select site", disabled = false }) {
  return (
    <SearchableSelect
      testId={testId}
      value={value || ""}
      onValueChange={onChange}
      disabled={disabled}
      placeholder={placeholder}
      options={sites.filter((s) => s.site_id).map((s) => ({ value: s.site_id, label: s.display_label || s.label, testId: `${testId}-option-${s.site_id}` }))}
    />
  );
}
